import { getGlobalAccessTokenApi } from "@services/getGlobalAccessTokenApi";
import { getPbiAccessTokenApi } from "@services/getPbiAccessTokenApi";
import { getUserDetailsApi } from "@services/getUserDetailsApi";
// import { getEmployeeIdApi } from "@services/DRM/getEmployeeIdApi";
import { loginApi } from "@services/loginApi";
import { getTerritoryApi } from "@services/MarketWorking/MyTeam/getTerritoryApi";
import { createUsageLogApi } from "@services/PowerBi/createUsageLogApi";
import {
  GET_USER_ACCESS_TOKEN_SUCCESS,
  GET_USER_ACCESS_TOKEN_FAIL,
  GET_PCMS_ACCESS_TOKEN_SUCCESS,
  GET_PCMS_ACCESS_TOKEN_FAIL,
  GET_GLOBAL_ACCESS_TOKEN_SUCCESS,
  GET_GLOBAL_ACCESS_TOKEN_FAIL,
  GET_PBI_ACCESS_TOKEN_SUCCESS,
  GET_PBI_ACCESS_TOKEN_FAIL,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_DETAILS_FAIL,
  GET_TERRITORY_SUCCESS,
  GET_TERRITORY_FAIL,
  LOGOUT,
  GET_USER_DETAILS_EMPTY,
  SET_SELECTED_INSIGHTS,
  GET_SECONDARY_SALES_ACHIEVED_FAIL,
  GET_BAR_GRAPH_FAIL,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_FAIL,
  GET_USER_TYPE_FAIL,
  SET_POWERBI_USAGE_LOG_SUCCESS,
  SET_POWERBI_USAGE_LOG_FAIL,
  SET_MASTER_FETCH_TIMESTAMP,
  SET_IMPERSONATED_EMAIL,
  CLEAR_IMPERSONATED_EMAIL,
  SET_ORIGINAL_USER_EMAIL,
  CLEAR_ORIGINAL_USER_EMAIL,
} from "../constants/action-types";
import { setAlert } from "./alert-action";
import {
  getCheckInDealerDetails,
  getCheckInWSSDetails,
} from "./checkinDetails-actions";
import { getPastSrDetails } from "./pastInsights-actions";
import { getBarGraph, getMarketWorking } from "./homePage-actions";
import { getUpcomingTourPlan } from "./upcomingTourPlan-actions";
import { getFeedbackDetails } from "./getFeedback-action";
import { getDivisionGroup } from "./divisionGroup-action";
import {
  getSecondarySalesAcheived,
  getSecondarySalesAcheivedTrend,
  getSecondarySalesTargetAcheived,
  getSecondarySalesTargetAcheivedTrend,
} from "./secondarySales-actions";
import {
  getTeamsAverageTsiScore,
  getTeamsAverageTsrScore,
  getTeamsIncentive,
  getTeamsSop,
} from "./teams-action";
import {
  getWssAutoVAlueFtd,
  getWssAutoValueFtdTrend,
  getWssCodeForHORDM,
  getTownsForHORDM,
  getWssDarpanSyncDaysException,
  getWssWssInBlock,
  setCheckInFlag,
} from "./wss-actions";
import { getClusterCode } from "./zsm-action";
import { getAsmEncryptKey } from "./currentDayTour-action";
import { getTerritoryForHOUserApi } from "@services/hoUser/getTerritoryForHOUserApi";
import { getSH7CodeHoUserApi } from "@services/hoUser/getSH7CodeHoUserApi";
import {
  getOutletsBilledFtm,
  getOutletsBilledFtmTrend,
  getRsmFtm,
  getRsmFtmTrend,
} from "./salesOperation-action";
import { getHoNsmEmail } from "./hoUser-action";
import { getProductNameApi } from "@services/MarketWorking/MyTeam/getProductNameApi";
import { getUniqueListBy } from "@components/Common/Function";
import { getMyUserFeedback } from "./myuser-actions";
import { getRMDMClusterCode } from "./rmdm-action";
import { removeMVRDraftDetails } from "./mvr-action";
import { getBmWss } from "./bms-action";
import { getSalesGroupUserDetails } from "./getSalesGroupUser-action";
import { getRBDMCode } from "./getRBDMCode-action";
import { getUserType } from "./userType-action";
import { getUserTypeApi } from "@services/getUserTypeApi";
import { getClusterCodeApi } from "@services/zsm/getClusterCodeApi";
import { getPCMSAccessTokenApi } from "@services/getPCMSAccessTokenApi ";
import { getSalesforceAccessTokenAPI } from "@services/getSalesforceAccessTokenAPI";
import { clearTokenTimer } from "@utils/tokenTimer";

import { SaveSelectedSalesGroupCode } from "./saveSelectedSalesGroup-action";

let count = 0;

export const getGlobalAccessToken = () => async (dispatch) => {
  const response = await getGlobalAccessTokenApi();
  if (response?.data?.success === true) {
    dispatch({
      type: GET_GLOBAL_ACCESS_TOKEN_SUCCESS,
      payload: response?.data?.accessToken,
    });
  } else {
    dispatch({ type: GET_GLOBAL_ACCESS_TOKEN_FAIL });
  }
};

export const getUserAccessToken =
  ({ username, password }) =>
  async (dispatch) => {
    const response = await loginApi({ username, password });
    if (response?.status === 200) {
      localStorage.removeItem("pop_status");
      getAccessToken(dispatch, response, "").then((status) => {
        // Only fetch essential user data on login
        dispatch(getUserDetails({ username }));
      });
    } else {
      dispatch({
        type: GET_USER_ACCESS_TOKEN_FAIL,
      });
      dispatch(setAlert(response?.error, "error"));
    }
  };

export const getSalesforceAccessToken = (username) => async (dispatch) => {
  try {
    const response = await getSalesforceAccessTokenAPI(username);
    if (response?.status === 200) {
      localStorage.removeItem("pop_status");
      await getAccessToken(dispatch, response, "SSO");
      // Only fetch essential user data on login
      dispatch(getUserDetails({ username }));
      return response;
    } else {
      dispatch({ type: GET_USER_ACCESS_TOKEN_FAIL });
      dispatch(setAlert(response?.error, "error"));
      throw new Error("Failed to fetch access token");
    }
  } catch (error) {
    console.error("Error in getSalesforceAccessToken:", error);
    throw error;
  }
};

export const getAccessToken = (dispatch, response, type) => {
  let resPayload = {};
  if (type === "SSO") {
    resPayload = {
      accessToken: response?.data?.access_token,
      isSSOAuthenticated: true,
      creationDate: new Date().toISOString(), // Add creation timestamp for SSO tokens
    };
  } else {
    resPayload = {
      accessToken: response?.data?.accessToken?.accessToken,
      isSSOAuthenticated: false,
      creationDate: new Date().toISOString(), // Add creation timestamp for regular tokens
    };
  }
  return new Promise((resolve, reject) => {
    dispatch({
      type: GET_USER_ACCESS_TOKEN_SUCCESS,
      payload: resPayload,
    });
    resolve("successfully");
  });
};

export const getPbiAccessToken = (userEmail, forceRefresh = false) => async (dispatch, getState) => {
  // Check if we have a cached token that hasn't expired
  const { pbiToken } = getState();
  const now = Date.now();
  
  // Use cached token if:
  // 1. Not forcing refresh
  // 2. Token exists
  // 3. Token hasn't expired (with 5 minute buffer)
  if (
    !forceRefresh &&
    pbiToken?.pbiAccessToken &&
    pbiToken?.pbiTokenExpiry &&
    pbiToken.pbiTokenExpiry > now + (5 * 60 * 1000) // 5 minute buffer
  ) {
    console.log('✅ Using cached PowerBI token (valid for all reports)');
    return; // Use cached token
  }

  console.log('🔄 Fetching new PowerBI workspace token');
  const response = await getPbiAccessTokenApi(userEmail);
  if (response?.data?.success === true) {
    // PowerBI embed tokens typically expire in 1 hour
    const expiry = now + (60 * 60 * 1000); // 1 hour from now
    
    dispatch({
      type: GET_PBI_ACCESS_TOKEN_SUCCESS,
      payload: {
        token: response?.data?.accessToken,
        expiry: expiry,
        reportId: null, // Not report-specific
      },
    });
  } else {
    dispatch({ type: GET_PBI_ACCESS_TOKEN_FAIL });
  }
};

const getPCMSAccessToken = (data) => async (dispatch) => {
  const response = await getPCMSAccessTokenApi(data.Email);
  if (response?.data?.success === true) {
    dispatch({
      type: GET_PCMS_ACCESS_TOKEN_SUCCESS,
      payload: response?.data?.accessToken,
    });
  } else {
    dispatch({ type: GET_PCMS_ACCESS_TOKEN_FAIL });
  }
};

export const getUserDetails =
  ({ username }) =>
  async (dispatch, getState) => {
    const response = await getUserDetailsApi({ username });
    if (response?.success === true) {
      // Call to get PCMS access token
      const res = response?.data?.records[0];
      dispatch(getPCMSAccessToken(res));

      getUserDetails1(dispatch, response).then(
        async ([
          SH_Code__c,
          Title,
          Division,
          Sales_Group_Code__c,
          count,
          Email,
          // MConnect_Role__c,
          Id,
        ]) => {
          if (count <= 1) {
            const currentDate = new Date();
            const thirtyDaysAgo = currentDate;
            thirtyDaysAgo.setDate(currentDate.getDate() - 30);
            let draftedForm = getState()?.mvrDraft?.draft?.[Id];
            if (draftedForm?.length) {
              draftedForm = await draftedForm?.filter(
                (item) => new Date(item?.createdDate) > thirtyDaysAgo
              );
              const drafts = {
                ...getState()?.mvrDraft?.draft,
                [Id]: draftedForm,
              };
              dispatch(removeMVRDraftDetails(drafts));
            }

            // To get User Type
            if (Email) {
              const response = await getUserTypeApi(Email);
              if (response?.success === true) {
                getUserType(dispatch, response).then(async ([HO_Role__c]) => {
                  if (HO_Role__c) {
                    if (HO_Role__c === "RBDM Collaborator" || HO_Role__c === "MH3") {
                      // Territory is now loaded inside getRMDMClusterCode using cluster codes (SH3_Code__c IN)
                      dispatch(getRMDMClusterCode(HO_Role__c, Email));
                      dispatch(getProduct(Division, Sales_Group_Code__c));
                      dispatch(
                        getSalesGroupUserDetails(Sales_Group_Code__c, Division)
                      );
                    }

                    if (
                      (HO_Role__c === "MH3" ||
                        HO_Role__c === "RBDM Collaborator") &&
                      Sales_Group_Code__c === "105"
                    ) {
                      dispatch(getRBDMCode(Email));
                    }
                    // } else {
                    if (
                      (Title === "HO Collaborator" || Title === "TMM" ||
                        Title === "HO Auditor" ||
                        Title === "SH7") &&
                      (!Sales_Group_Code__c ||
                        Division === 70 ||
                        Division === 30) &&
                      HO_Role__c !== "RBDM Collaborator" &&
                      HO_Role__c !== "MH3"
                    ) {
                      dispatch(getDivisionGroup());
                    }
                    // to get Dashboard details, territory ,cluster code ,sh7code when user is HO Collaborator (No popup Scenerio)
                    if (
                      (Title === "HO Collaborator" || Title === "TMM" ||
                        Title === "HO Auditor" ||
                        Title === "SH7") &&
                      Sales_Group_Code__c !== null &&
                      Division !== 70 &&
                      HO_Role__c !== "RBDM Collaborator" &&
                      HO_Role__c !== "MH3"
                    ) {
                      const res = await getSH7CodeHoUserApi(
                        Division,
                        Sales_Group_Code__c
                      );
                      dispatch(
                        getWssForHoRmDm(
                          res,
                          Title,
                          Division,
                          Sales_Group_Code__c
                        )
                      );
                      dispatch(
                        getWssForHoRmMh(
                          res,
                          Title,
                          Division,
                          Sales_Group_Code__c
                        )
                      );
                      // dispatch(
                      //   getTownForHoRmMh(
                      //     res,
                      //     Title,
                      //     Division,
                      //     Sales_Group_Code__c
                      //   )
                      // );
                      dispatch(getProduct(Division, Sales_Group_Code__c));
                      dispatch(getOutletsBilledFtm(res, Title));
                      dispatch(getOutletsBilledFtmTrend(res, Title));
                      dispatch(getRsmFtm(res, Title));
                      dispatch(getRsmFtmTrend(res, Title));
                      dispatch(getSecondarySalesAcheived(res, Title));
                      dispatch(getSecondarySalesAcheivedTrend(res, Title));
                      dispatch(getSecondarySalesTargetAcheived(res, Title));
                      dispatch(
                        getSecondarySalesTargetAcheivedTrend(res, Title)
                      );
                      dispatch(getTeamsAverageTsiScore(res, Title));
                      // dispatch(
                      //   getTeamsAverageTsiScoreTrend(res, Title)
                      // );
                      dispatch(getTeamsAverageTsrScore(res, Title));
                      // dispatch(
                      //   getTeamsAverageTsrScoreTrend(res, Title)
                      // );
                      dispatch(getTeamsIncentive(res, Title));
                      // dispatch(
                      //   getTeamsIncentiveTrend(res, Title)
                      // );
                      dispatch(getTeamsSop(res, Title));
                      // dispatch(getTeamsSopTrend(res, Title));
                      dispatch(getWssAutoVAlueFtd(res, Title));
                      dispatch(getWssAutoValueFtdTrend(res, Title));
                      dispatch(getWssWssInBlock());
                      dispatch(getWssDarpanSyncDaysException(res, Title));

                      dispatch(
                        getClusterCode(
                          res,
                          Title,
                          Division,
                          Sales_Group_Code__c
                        )
                      );
                      const data = {
                        divisionGroup: Division,
                        salesGroup: Sales_Group_Code__c,
                      };
                      const { divisionGroup, salesGroup } = data;
                      dispatch(
                        getTerritoryForHOUser({ divisionGroup, salesGroup })
                      );
                      dispatch(getHoNsmEmail(salesGroup));
                    }
                  }
                });
              } else {
                dispatch({ type: GET_USER_DETAILS_FAIL });
              }
            }

            if (
              Title === "SH3" ||
              Title === "SH6" ||
              Title === "SH5" ||
              Title === "SH7" ||
              Title === "SH4"
            ) {
              dispatch(getTerritory(SH_Code__c, Title));
              dispatch(getProduct(Division, Sales_Group_Code__c));
              dispatch(getAsmEncryptKey(SH_Code__c));
            }

            //To get Cluster Code when user is (ZSM and NSM)
            if (
              Title === "SH6" ||
              Title === "SH5" ||
              Title === "SH7" ||
              Title === "SH4"
            ) {
              dispatch(
                getClusterCode(
                  SH_Code__c,
                  Title,
                  Title === "SH7" ? Division : undefined,
                  Title === "SH7" ? Sales_Group_Code__c : undefined
                )
              );
            }

            // if (MConnect_Role__c === "RBDM Collaborator") {
            //   dispatch(getRMDMClusterCode("RBDM Collaborator", Email));
            //   dispatch(getProduct(Division, Sales_Group_Code__c));
            //   dispatch(getSalesGroupUserDetails(Sales_Group_Code__c, Division));
            // }

            // if ((Title === "MH3" || MConnect_Role__c === "RBDM Collaborator") && Sales_Group_Code__c == '105') {
            //   dispatch(getRBDMCode(Email));
            // }

            // To get Dashboard details when user is (BM ,ZSM and NSM)
            if (
              Title === "SH3" ||
              ((Title === "SH6" ||
                Title === "SH5" ||
                Title === "SH7" ||
                Title === "SH4") &&
                Division !== 70)
            ) {
              dispatch(getSecondarySalesAcheived(SH_Code__c, Title));
              dispatch(getSecondarySalesAcheivedTrend(SH_Code__c, Title));
              dispatch(getSecondarySalesTargetAcheived(SH_Code__c, Title));
              dispatch(getSecondarySalesTargetAcheivedTrend(SH_Code__c, Title));
              dispatch(getTeamsAverageTsiScore(SH_Code__c, Title));
              // dispatch(getTeamsAverageTsiScoreTrend(SH_Code__c, Title));
              dispatch(getTeamsAverageTsrScore(SH_Code__c, Title));
              // dispatch(getTeamsAverageTsrScoreTrend(SH_Code__c, Title));
              dispatch(getTeamsIncentive(SH_Code__c, Title));
              // dispatch(getTeamsIncentiveTrend(SH_Code__c, Title));
              dispatch(getTeamsSop(SH_Code__c, Title));
              // dispatch(getTeamsSopTrend(SH_Code__c, Title));
              dispatch(getWssAutoVAlueFtd(SH_Code__c, Title));
              dispatch(getWssAutoValueFtdTrend(SH_Code__c, Title));
              dispatch(getWssWssInBlock());
              dispatch(getWssDarpanSyncDaysException(SH_Code__c, Title));
              dispatch(getOutletsBilledFtm(SH_Code__c, Title));
              dispatch(getOutletsBilledFtmTrend(SH_Code__c, Title));
              dispatch(getRsmFtm(SH_Code__c, Title));
              dispatch(getRsmFtmTrend(SH_Code__c, Title));
            }

            if (Title === "SH3") {
              dispatch(setCheckInFlag(true));
            }
          }
        }
      );
    } else {
      sessionExpireTimeout(dispatch);
      dispatch({ type: GET_USER_DETAILS_FAIL });
    }
  };

export const logout =
  (isUpdated = false, version) =>
  async (dispatch) => {
    count = 0;
    clearTokenTimer();

    // Clear impersonation and original user on logout
    localStorage?.removeItem("impersonatedEmail");
    localStorage?.removeItem("originalUserEmail");
    dispatch({ type: CLEAR_IMPERSONATED_EMAIL });
    dispatch({ type: LOGOUT });
    dispatch({ type: GET_USER_DETAILS_EMPTY });
    dispatch({ type: GET_SECONDARY_SALES_ACHIEVED_FAIL });
    dispatch({ type: GET_BAR_GRAPH_FAIL });
    dispatch({ type: GET_USER_TYPE_FAIL });
    dispatch(SaveSelectedSalesGroupCode(""));
    
    if (isUpdated) {
      dispatch(
        setAlert(
          `App updated to version ${version} ,Please Login again`,
          "error"
        )
      );
    }
  };

const getUserDetails1 = (dispatch, response) => {
  if (
    response?.data?.records?.[0]?.Profile?.Name === "HO Colloaborator" ||
    response?.data?.records?.[0]?.Profile?.Name === "CWP Colloaborator"
  ) {
    response.data.records[0].Title = "HO Collaborator";
  }
  ++count;
  const record = response?.data?.records?.[0];

  return new Promise((resolve) => {
    const email = record?.Email;

    // Dispatch user details immediately so territory/WSS loading is not blocked
    dispatch({
      type: GET_USER_DETAILS_SUCCESS,
      payload: { ...record, count },
    });

    // // Fire-and-forget: fetch employee code and update store when ready
    // if (email) {
    //   getEmployeeIdApi(email)
    //     .then((res) => {
    //       const employeeCode = res?.data?.records?.[0]?.Employee_Code__c || null;
    //       dispatch({
    //         type: GET_USER_DETAILS_SUCCESS,
    //         payload: { ...record, Employee_Code__c: employeeCode, count },
    //       });
    //     })
    //     .catch(() => null);
    // }

    resolve([
      record?.SH_Code__c,
      record?.Title,
      record?.Division,
      record?.Sales_Group_Code__c,
      count,
      email,
      record?.Id,
    ]);
  });
};

// Territory for non-Ho user
export const getTerritory = (UserSH_Code__c, Title) => async (dispatch) => {
  const response = await getTerritoryApi({ UserSH_Code__c, Title });
  if (response?.success === true) {
    if (Title === "SH3") {
      dispatch(getBmWss(response?.data?.records));
    }
    dispatch({
      type: GET_TERRITORY_SUCCESS,
      payload: response?.data?.records,
    });
  } else {
    dispatch({ type: GET_TERRITORY_FAIL });
  }
};

export const getSH7Code = (UserSH_Code__c, Title) => async (dispatch) => {
  const response = await getSH7CodeHoUserApi({ UserSH_Code__c, Title });
  if (response?.success === true) {
    dispatch({
      type: GET_TERRITORY_SUCCESS,
      payload: response?.data?.records,
    });
  } else {
    dispatch({ type: GET_TERRITORY_FAIL });
  }
};

export const getWssForHoRmMh =
  (sh7code, Title, division, salesGroupCode) => async (dispatch) => {
    var code = sh7code;
    const clusterRes = await getClusterCodeApi(
      code,
      Title,
      division,
      salesGroupCode
    );
    if (clusterRes?.success === true) {
      dispatch(getWssCodeForHORDM(clusterRes));
    }
  };

export const getTownForHoRmMh =
  (sh7code, Title, division, salesGroupCode) => async (dispatch) => {
    var code = sh7code;
    const clusterRes = await getClusterCodeApi(
      code,
      Title,
      division,
      salesGroupCode
    );
    if (clusterRes?.success === true) {
      dispatch(getTownsForHORDM(clusterRes));
    }
  };

export const getWssForHoRmDm = (Title, Email) => async (dispatch) => {
  const clusterRes = await getClusterCodeApi("", Title, "", "", Email);
  if (clusterRes?.success === true) {
    dispatch(getWssCodeForHORDM(clusterRes));
  }
};

// Territory for Ho user
export const getTerritoryForHOUser =
  ({ divisionGroup, salesGroup }) =>
  async (dispatch) => {
    const response = await getTerritoryForHOUserApi({
      divisionGroup,
      salesGroup,
    });
    if (response?.status === 200) {
      dispatch({
        type: GET_TERRITORY_SUCCESS,
        payload: response?.data?.records,
      });
    } else {
      dispatch({ type: GET_TERRITORY_FAIL });
    }
  };

// product for BM
export const getProduct = (divisionGroup, salesGroup) => async (dispatch) => {
  const response = await getProductNameApi(divisionGroup, salesGroup);
  if (response?.status === 200) {
    dispatch({
      type: GET_PRODUCT_SUCCESS,
      payload: getUniqueListBy(
        response?.data?.records,
        "Product_Group_3_Description__c"
      ),
    });
  } else {
    dispatch({ type: GET_PRODUCT_FAIL });
  }
};

// Dedup flag — prevents multiple "Session Expired" toasts when many concurrent
// API calls all fail with ERR_BAD_REQUEST (e.g. after the token-refresh 400)
let _sessionExpireAlertShown = false;

export const _suppressSessionExpireAlert = () => {
  _sessionExpireAlertShown = true;
  setTimeout(() => { _sessionExpireAlertShown = false; }, 5000);
};

export const sessionExpireTimeout = (dispatch) => {
  // Already on the login page → nothing to do (interceptor handles redirect)
  if (window.location.pathname === '/login') return;
  // Already shown within this expiry cycle → suppress duplicates
  if (_sessionExpireAlertShown) return;
  _sessionExpireAlertShown = true;
  // Reset flag after 5 s so future expiry events work correctly
  setTimeout(() => { _sessionExpireAlertShown = false; }, 5000);

  sessionExpire(dispatch).then((status) => {
    dispatch(setAlert("Session Expired ,Please Login again", "error"));
  });
};

const sessionExpire = (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(logout());
    resolve("successfully");
  });
};

export const updateSelectedInsights = (insights) => {
  return {
    type: SET_SELECTED_INSIGHTS,
    payload: insights,
  };
};

export const createUsageLog =
  (userEmail, report_id, page_id, page_name) => async (dispatch) => {
    try {
      const response = await createUsageLogApi(
        userEmail,
        report_id,
        page_id,
        page_name
      );
      if (response?.data?.data) {
        dispatch({ type: SET_POWERBI_USAGE_LOG_SUCCESS });
      } else {
        dispatch({ type: SET_POWERBI_USAGE_LOG_FAIL });
      }
    } catch (error) {
      dispatch({ type: SET_POWERBI_USAGE_LOG_FAIL });
    }
  };

export const fetchAllMasters = (username) => async (dispatch) => {
  if (username) {
    await dispatch(getUserDetails({ username }));
  }
  dispatch(getBarGraph());
  dispatch(getMarketWorking());
  dispatch(getCheckInDealerDetails());
  dispatch(getCheckInWSSDetails());
  dispatch(getUpcomingTourPlan());
  dispatch(getPastSrDetails());
  dispatch(getFeedbackDetails());
  dispatch(getMyUserFeedback());
  dispatch(setMasterFetchTimestamp());
};

export const setMasterFetchTimestamp = () => {
  return {
    type: SET_MASTER_FETCH_TIMESTAMP,
    payload: Date.now(),
  };
};

export const setImpersonatedEmail = (impersonatedEmail, originalUserEmail) => (dispatch) => {
  dispatch({ type: SET_IMPERSONATED_EMAIL, payload: impersonatedEmail });
  if (originalUserEmail) {
    dispatch({ type: SET_ORIGINAL_USER_EMAIL, payload: originalUserEmail });
  }
};

export const clearImpersonatedEmail = () => (dispatch) => {
  dispatch({ type: CLEAR_IMPERSONATED_EMAIL });
  dispatch({ type: CLEAR_ORIGINAL_USER_EMAIL });
};
